import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";
import { smkMajorService } from "../../../services/smk-major.service";

export default function SMKMajorForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: smkMajorService.findById,
    queryKey: ["smk-major"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: smkMajorService,
    form: form,
    messageApi: messageApi,
    queryKey: "smk-major",
    route: "/master-data/smk-major",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Jurusan SMK"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/smk-major"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Jurusan SMK"
            name="name"
            rules={[
              { required: true, message: "Nama Jurusan SMK harus diisi" },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
